import { Link as MuiLink, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { ReleaseRef } from "../../../../utils/icGovernance";
import { StatusChip, itemUrlById } from "../governanceStatus";
import { FAINT } from "../detail/ui";

/** "TD-REL-2 v1.4 — Spring update" */
export const releaseLabel = (r: ReleaseRef) =>
  [[r.displayId, r.version ? `v${r.version}` : null].filter(Boolean).join(" "), r.title]
    .filter(Boolean)
    .join(" — ");

/** A release reference linked to its detail page, with its status chip. */
const ReleaseLink = ({ release, empty = "—" }: { release: ReleaseRef | null; empty?: string }) => {
  if (!release) {
    return (
      <Typography component="span" variant="body2" sx={{ color: FAINT }}>
        {empty}
      </Typography>
    );
  }
  return (
    <Stack direction="row" spacing={1} alignItems="center" useFlexGap sx={{ flexWrap: "wrap" }}>
      <MuiLink
        component={RouterLink}
        to={itemUrlById(release.displayId || release.id)}
        sx={{ fontWeight: 600, overflowWrap: "anywhere" }}
      >
        {releaseLabel(release)}
      </MuiLink>
      {release.status ? <StatusChip kind="RELEASE" status={release.status} /> : null}
    </Stack>
  );
};

export default ReleaseLink;
